import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DateRange } from '@angular/material/datepicker';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DatePicker, DateTimePicker } from '@syncfusion/ej2-angular-calendars';
import { UserRightsService } from '../../../services/user-rights.service';
import { DropDownList, MultiSelect } from '@syncfusion/ej2-angular-dropdowns';
import {
  Column,
  columnVisibilityChanged,
  CommandClickEventArgs,
  CommandColumnService,
  CommandModel,
  EditService,
  EditSettingsModel,
  GridComponent,
  GroupSettingsModel,
  IEditCell,
  QueryCellInfoEventArgs,
  ToolbarItems,
  ToolbarService,
} from '@syncfusion/ej2-angular-grids';
import {
  MaskedTextBox,
  TextBox,
  Uploader,
} from '@syncfusion/ej2-angular-inputs';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { Query } from '@syncfusion/ej2-data';
import { ServiceWithCacheService } from 'src/app/core/cachableServices/service-with-cache.service';
import { timeStringToDate } from 'src/app/core/commonFunction/common';
import { UnsubscribeOnDestroyAdapter } from 'src/app/core/destroyAdapter/unsubscribe-on-destroy-adapter';
import {
  AdminGeneratedService,
  AvaiablePartnerContourAgreementsReq,
  CustomerContactsDTO,
  CustomerFileUploadDTO,
  RequestFilter,
  PartnerAgreementsReq,
  CustomerFileUploadReq,
  Condition,
  FileUploadDetailRes,
  ServiceType,
} from 'src/app/core/services/AdminService/admin-service-generate';
import { ToastService } from 'src/app/core/services/toast.service';
import { runInThisContext } from 'vm';

@Component({
  selector: 'app-fast-transaction-dialog',
  templateUrl: './fast-transaction-dialog.component.html',
  styleUrls: ['./fast-transaction-dialog.component.css'],
  providers: [EditService, ToolbarService, CommandColumnService],
})
export class FastTransactionDialogComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit
{
  @ViewChild('toast') toast: ElementRef;
  @ViewChild('grdfastTransaction') public grdfastTransaction: GridComponent;
  @ViewChild('grdresult') public grdresult: GridComponent;
  // public data: Object[];
  // public data: CustomerContactsDTO[] = [];
  public selectionOptions: Object;
  isErrorServer = false;
  public groupOptions: GroupSettingsModel;
  public setFocus: any;
  agreementCodeData = [];
  ErrorDataList: FileUploadDetailRes[];
  requestFilter: RequestFilter[] = [];
  fastTransactionData: CustomerFileUploadDTO[] = [];
  serviceListData = [
    { Identity: 2, Title: 'E-Fatura' },
    { Identity: 22, Title: 'E-Arşiv Fatura' },
    { Identity: 42, Title: 'E-Bilet' },
    { Identity: 52, Title: 'E-İrsaliye' },
    { Identity: 72, Title: 'E-Serbest Meslek Makbuzu' },
    { Identity: 82, Title: 'E-Müstahsil Makbuzu' },
    { Identity: 132, Title: 'E-Dekont' },
    { Identity: 152, Title: 'E-Adisyon' },
    { Identity: 162, Title: 'E-Sigorta Komisyon' },
    { Identity: 5000, Title: 'E-Defter' },
    { Identity: 5010, Title: 'E-Defter Saklama' },
    { Identity: 5020, Title: 'E-Muhasabe Fişi' },
    { Identity: 5050, Title: 'E-Envanter Defter' },
    { Identity: 5060, Title: 'E-Envanter Defter Saklama' },
    { Identity: 6000, Title: 'ESU Faturası' },
  ];
  public formatoptions: Object;
  public cityfields = { text: 'Title', value: 'Identity' };
  public showPkAndGbcolumn: boolean = true;
  public editSettings: EditSettingsModel;
  public toolbar: ToolbarItems[];
  public CustomerDataList: CustomerFileUploadDTO[];
  public cityParams: IEditCell;
  public citySubdivisionPArams: IEditCell;
  public serviceParams: IEditCell;
  public agreementParams: IEditCell;
  public resizeSettings = { mode: 'Auto' };
  public commands: CommandModel[];
  cityData = [];
  citySubdivisionData = [];
  isRequestTypeBeginEdit: boolean = true;

  cityName: string = null;
  citySubdivisionName: string = null;
  IdCount: number = 1;
  gridVKNTCKNRequired: Object;
  gridCityRequired: Object;
  gridCitySubdivisonRequired: Object;
  gridEmail: Object;
  gridRequired: Object;
  gridServiceRequired: Object;
  gridActivationTimeRequired: Object;
  gridAgreementStartTimeRequired: Object;
  gridAgreementEndTimeRequired: Object;
  gridPkRequired: Object;
  gridGbRequired: Object;

  public isKeyPressed = false;

  public textBoxPkParams: IEditCell;
  public textBoxPkElem: HTMLElement;
  public textBoxPkObj: TextBox;

  public textBoxGbParams: IEditCell;
  public textBoxGbElem: HTMLElement;
  public textBoxGbObj: TextBox;

  public dateMask: MaskedTextBox;
  public maskedTextBoxTelephone: IEditCell;
  public elem: HTMLElement;

  public dateTimePickerAgreementParams: IEditCell;
  public dateTimePickerAgreementElem: HTMLElement;
  public dateTimePickerAgreementObj: DatePicker;

  agreementDateShow = false;

  public startDateEditOptions?: Object;
  public endDateEditOptions?: Object;
  public elemStartDate?: HTMLElement;
  public elemEndDate?: HTMLElement;
  public startDateObject?: DatePicker;
  public endDateObject?: DatePicker;

  public cityElem: HTMLElement;
  public cityObj: DropDownList;

  public citySubdivisonElem: HTMLElement;
  public citySubdivisonObj: DropDownList;

  public serviceElem: HTMLElement;
  public serviceObj: MultiSelect;

  public agreementElem: HTMLElement;
  public agreementObj: DropDownList;

  logoFileName: string = '';
  signatureFileName: string = '';
  logoImageBase64Data: string = '';
  signatureImageBase64Data: string = '';

  constructor(
    private translateService: TranslateService,
    private adminGenerateService: AdminGeneratedService,
    private cacheableService: ServiceWithCacheService,
    private toastService: ToastService,
    public dialogRef: MatDialogRef<DialogComponent>,
    public userRightsService: UserRightsService,
  ) {
    super();
  }

  onDoubleClick(args: any): void {
    this.setFocus = args.column; // Get the column from Double click event
  }

  ngOnInit(): void {
    this.groupOptions = { columns: ['customerId'] };
    this.selectionOptions = {
      type: 'Multiple',
      mode: 'Cell',
      cellSelectionMode: 'Box',
    };
    // this.getCity(1);
    this.getAgreementCode();
    this.editSettings = {
      allowEditing: true,
      allowAdding: true,
      allowDeleting: true,
      mode: 'Dialog',
    };
    this.cityAndCitySubdivisonAndService();
    this.toolbar = ['Add', 'Update', 'Delete', 'Cancel'];
    // this.formatoptions = { type: 'dateTime', format: 'M/d/y hh:mm a' };

    this.formatoptions =
      localStorage.getItem('lang') === 'tr-TR'
        ? { type: 'dateTime', format: 'dd.MM.yyyy HH:mm' }
        : { type: 'dateTime', format: 'yyyy.MM.dd HH:mm' };

    this.commands = [
      {
        type: 'Edit',
        buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' },
      },
      {
        type: 'Delete',
        buttonOption: { cssClass: 'e-flat', iconCss: 'e-delete e-icons' },
      },
      {
        type: 'Save',
        buttonOption: { cssClass: 'e-flat', iconCss: 'e-update e-icons' },
      },
      {
        type: 'Cancel',
        buttonOption: { cssClass: 'e-flat', iconCss: 'e-cancel-icon e-icons' },
      },
    ];
  }

  dataBound() {
    // this.grdfastTransaction.autoFitColumns([]);
    (this.grdfastTransaction.columns[0] as any).isPrimaryKey = 'true';
  }

  dataBoundResult() {
    this.grdresult.autoFitColumns([]);
  }

  customiseCell(args: QueryCellInfoEventArgs) {
    if (
      args.column.field === 'activationTime' &&
      args.data['activationTime'] == null &&
      args.data['serviceId'] != null
    ) {
      (args.cell as any).style.backgroundColor = 'red';
    }

    if (
      args.column.field === 'PK' &&
      (args.data['serviceId'] == 'E-Fatura' ||
        args.data['serviceId'] == 'E-İrsaliye')
    ) {
      if (
        args.data['PK'] == null ||
        args.data['PK'] == undefined ||
        args.data['PK'] == ''
      ) {
        (args.cell as any).style.backgroundColor = 'red';
      }
    }

    if (
      args.column.field === 'GB' &&
      (args.data['serviceId'] == 'E-Fatura' ||
        args.data['serviceId'] == 'E-İrsaliye')
    ) {
      if (
        args.data['GB'] == null ||
        args.data['GB'] == undefined ||
        args.data['GB'] == ''
      ) {
        (args.cell as any).style.backgroundColor = 'red';
      }
    }
  }

  getAgreementCode() {
    this.agreementCodeData = [];
    if (
      !this.userRightsService.getUserRightsIsEnabledWithKey(
        `Agreements_View_PartnerAgreement`,
      ) &&
      !this.userRightsService.getUserRightsIsEnabledWithKey(
        `Agreements_View_CustomerAgreement`,
      )
    ) {
      return;
    }

    const req = new AvaiablePartnerContourAgreementsReq({
      partnerId: '', //customiseCell() de set edılıyor.
    });

    this.subs.add(
      this.adminGenerateService.avaiablePartnerAgreementsAll(req).subscribe(
        (res) => {
          this.agreementCodeData = res.map((res) => ({
            Identity: res.id,
            Title: res.code,
            data: res,
          }));
        },
        (err) => {},
      ),
    );
  }

  getCity(countryId) {
    // setTimeout(() => { this.spinner.show() }, 0);
    this.subs.add(
      this.adminGenerateService.cities(1).subscribe(
        (res) => {
          this.cityData = res.cities.map((city) => ({
            Identity: city.id,
            Title: city.name,
            Data: city.name,
          }));
        },
        (err) => {
          console.log(err);
        },
      ),
    );
  }

  getCitySubdivision(cityId) {
    // setTimeout(() => { this.spinner.show() }, 0);
    this.subs.add(
      this.adminGenerateService.citySubdivisions(cityId).subscribe(
        (res) => {
          this.citySubdivisionData = res.citySubdivisions.map((citySub) => ({
            Identity: citySub.id,
            Title: citySub.name,
            Data: citySub.name,
          }));
          ((this.citySubdivisonObj.dataSource = this.citySubdivisionData),
            (this.citySubdivisonObj.enabled = true));
          this.citySubdivisonObj.dataBind();
        },
        (err) => {
          console.log(err);
          // this.spinner.hide();
        },
      ),
    );
  }

  load() {
    this.gridLocalizationConst();
    // this.grdfastTransaction.autoFitColumns([]);
    // (this.grdfastTransaction.columns[0] as any).isPrimaryKey = 'true';
    this.gridGbRequired = { required: false };
    this.gridPkRequired = { required: false };
    this.gridAgreementStartTimeRequired = { required: false };
    this.gridAgreementEndTimeRequired = { required: false };
    this.gridVKNTCKNRequired = {
      required: [true, 'VKN/TCKN zorunludur'],
      maxLength: [11, 'Max 11 Hane'],
      minLength: [10, 'Min 10 Hane'],
    };
    this.gridCityRequired = { required: [true, 'Şehir zorunludur'] };
    this.gridCitySubdivisonRequired = { required: [true, 'İlçe zorunludur'] };
    this.gridEmail = {
      required: [true, 'Mail zorunludur'],
      email: [true, 'Mail formatında olmalıdır'],
    };
    this.gridServiceRequired = { required: [true, 'Hizmet zorunludur'] };
    this.gridRequired = { required: [true, 'Zorunlu alan'] };
    this.gridActivationTimeRequired = {
      required: [true, 'Aktivasyon tarihi zorunludur'],
    };
  }

  addMinutesToDate = (date, minutes) =>
    new Date(date.getTime() + minutes * 60000);

  onConfirmClick() {
    const req = new CustomerFileUploadReq();
    console.log(this.grdfastTransaction.dataSource);
    let fileUpload: CustomerFileUploadDTO[] = [];
    var xxx = JSON.stringify(this.grdfastTransaction.dataSource);
    var yyy = JSON.parse(xxx);
    let newfileUpload;
    yyy.forEach((element) => {
      const serviceIdArray = element.serviceId?.split(',');
      serviceIdArray.forEach((item) => {
        fileUpload.push(
          new CustomerFileUploadDTO({
            firma_VKN_TCKN: element.customerId?.toString(),
            partner_VKN: JSON.parse(
              sessionStorage.getItem('SELECTED_CUSTOMER_IDENTITY'),
            ).toString(),
            İletişim_Ad: element?.contactName?.toString(),
            İletişim_Soyad: element?.contactSurname?.toString(),
            İletişim_Email: element?.contactEmail?.toString(),
            İletişim_Telefon: element?.contactTelephone?.toString(),
            // aktivasyon_Tarihi:
            //   item === 'E-Fatura'
            //     ? new Date().toLocaleTimeString('TR')
            //     : this.formatDate(element?.activationTime, true),

            aktivasyon_Tarihi: element.activationTime,
            hizmet_Tanımı: item,
            serviceType: item,
            partner_Sözleşme_Kodu: element?.agreementCode?.toString(),
            gb: element?.GB?.toString(),
            pk: element?.PK?.toString(),
            agreementStartDate: element.startDate
              ? this.formatDate(element.startDate)
              : null,
            agreementEndDate: element.endDate
              ? this.formatDate(element.endDate)
              : null,
            logoImageBase64Data: element.logoImageBase64Data,
            signatureImageBase64Data: element.signatureImageBase64Data,
          }),
        );
      });

      const eInvoiceIndex = fileUpload.findIndex(
        (x) => x.hizmet_Tanımı === 'E-Fatura',
      );
      newfileUpload = fileUpload.forEach((item, i) => {
        if (eInvoiceIndex >= 0 && i !== eInvoiceIndex) {
          fileUpload[i].aktivasyon_Tarihi = this.addMinutesToDate(
            new Date(Date.parse(fileUpload[eInvoiceIndex]?.aktivasyon_Tarihi)),
            5,
          ).toISOString();
        }

        fileUpload[i].aktivasyon_Tarihi =
          fileUpload[i]?.aktivasyon_Tarihi?.toString();
        fileUpload[i].serviceType = this.getServiceType(
          fileUpload[i]?.serviceType,
        );
      });
    });

    req.fileUpload = fileUpload;
    this.adminGenerateService.fastTransaction(req).subscribe(
      (res) => {
        if (res.isAdded && res.fileUploadDetailRes?.length == 0) {
          this.toastService.showSuccessToast(this.toast.nativeElement, {
            title: 'Toplu Firma Yükleme',
            content: 'İşleminiz Başarıyla Tamamlanmıştır',
          });
          this.dialogRef.close(true);
        } else if (res?.isAdded && res?.fileUploadDetailRes?.length != 0) {
          this.isErrorServer = true;
          this.ErrorDataList = res?.fileUploadDetailRes;
        } else {
          // this.isErrorServer = true;
        }
      },
      (err) => {
        this.isErrorServer = true;
        const message = JSON.parse(err?.response);
        this.ErrorDataList = message?.fileUploadDetailRes;
      },
    );
  }

  formatDate(date, returnString?): any {
    const d = new Date(date);
    const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
    const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
    const dateString = `${ye}-${mo}-${da}T00:00:00Z`;
    if (returnString) {
      return dateString;
    } else {
      return new Date(dateString);
    }
  }

  getServiceType(serviceType: string) {
    let selectedServiceType;
    switch (serviceType) {
      case 'E-Fatura':
        selectedServiceType = ServiceType.Usergb;
        break;
      case 'E-Arşiv Fatura':
        selectedServiceType = ServiceType.Earchive;
        break;
      case 'E-Bilet':
        selectedServiceType = ServiceType.Eticket;
        break;
      case 'E-İrsaliye':
        selectedServiceType = ServiceType.Edespatch;
        break;
      case 'E-Serbest Meslek Makbuzu':
        selectedServiceType = ServiceType.Esevoucher;
        break;
      case 'E-Müstahsil Makbuzu':
        selectedServiceType = ServiceType.Epreceipt;
        break;
      case 'E-Dekont':
        selectedServiceType = ServiceType.Ebreceipt;
        break;
      case 'E-Adisyon':
        selectedServiceType = ServiceType.Echeck;
        break;
      case 'E-Sigorta Komisyon':
        selectedServiceType = ServiceType.Eicommission;
        break;
      case 'E-Defter':
        selectedServiceType = ServiceType.Eledger;
        break;
      case 'E-Defter Saklama':
        selectedServiceType = ServiceType.Eledger_archive;
        break;
      case 'E-Muhasabe Fişi':
        selectedServiceType = ServiceType.Journal_entry;
        break;
      case 'E-Envanter Defter':
        selectedServiceType = ServiceType.Einventory_ledger;
        break;
      case 'E-Envanter Defter Saklama':
        selectedServiceType = ServiceType.Einventory_ledger_archive;
        break;
      case 'ESU Faturası':
        selectedServiceType = ServiceType.Esu_invoice;
        break;

      default:
        break;
    }
    return selectedServiceType;
  }

  gridLocalizationConst(): void {
    this.grdfastTransaction.getLocaleConstants()['EmptyRecord'] =
      this.translateService.instant('SYNCFS_GRID_LCLZ.EMPTY_RECORD');
    this.grdfastTransaction.getLocaleConstants()['Search'] =
      this.translateService.instant('SYNCFS_GRID_LCLZ.SEARCH');
    this.grdfastTransaction.getLocaleConstants()['ChooseColumns'] =
      this.translateService.instant('SYNCFS_GRID_LCLZ.CHOOSE_COLUMNS');
    this.grdfastTransaction.getLocaleConstants()['OKButton'] =
      this.translateService.instant('SYNCFS_GRID_LCLZ.OK_BUTTON');
    this.grdfastTransaction.getLocaleConstants()['CancelButton'] =
      this.translateService.instant('SYNCFS_GRID_LCLZ.CANCEL_BUTTON');
    this.grdfastTransaction.getLocaleConstants()['GroupDropArea'] =
      'Parametre Grubuna Göre Gruplamak İçin Kolonu Seçin Ve Sürükleyin';
    this.grdfastTransaction.getLocaleConstants()['Add'] =
      this.translateService.instant('SYNCFS_GRID_LCLZ.TOOLBAR_ADD_BUTTON');
    this.grdfastTransaction.getLocaleConstants()['Update'] =
      this.translateService.instant('SYNCFS_GRID_LCLZ.TOOLBAR_UPDATE_BUTTON');
    this.grdfastTransaction.getLocaleConstants()['Cancel'] = 'Vazgeç';
    this.grdfastTransaction.getLocaleConstants()['Save'] =
      this.translateService.instant('SYNCFS_GRID_LCLZ.TOOLBAR_SAVE_BUTTON');
    this.grdfastTransaction.getLocaleConstants()['AddFormTitle'] = 'Yeni Kayıt';
    this.grdfastTransaction.getLocaleConstants()['SaveButton'] = 'Kaydet';
    this.grdfastTransaction.getLocaleConstants()['EditFormTitle'] = '';
    this.grdfastTransaction.getLocaleConstants()['Delete'] = 'Sil';
  }

  actionComplete(e: any): void {
    const dialog = e.dialog;
    if (e.requestType === 'beginEdit') {
      e.form.elements.namedItem(this.setFocus.field).focus();
      this.injectFileInputsToDialog(dialog.element, e.rowData);
    }
    if (e.requestType === 'add') {
      dialog.width = 600;
      this.injectFileInputsToDialog(dialog.element, e.rowData);
    }
  }

  onActionBegin(args) {
    if (args.requestType === 'add') {
      this.cityObj = null;
      this.citySubdivisonObj = null;
      this.serviceObj = null;
      this.agreementObj = null;
      this.dateMask = null;
      this.gridPkRequired = { required: false };
      this.gridGbRequired = { required: false };
      this.gridAgreementStartTimeRequired = { required: false };
      this.gridAgreementEndTimeRequired = { required: false };
      this.logoImageBase64Data = undefined;
      this.signatureImageBase64Data = undefined;
    }

    // if(args.requestType === 'delete'){
    //   this.grdfastTransaction.dataSource.forEach((x, y) => {
    //     if (x.id === args.rowData.id) {
    //       this.personInfodata.splice(y, 1);
    //     }
    //   });
    // }

    if (args.requestType == 'save') {
      if (!args.data.Id) {
        args.data.Id = this.IdCount;
        this.IdCount = this.IdCount + 1;
      }
      // this.dateMask.value = null;
    }

    if (args.requestType === 'beginEdit') {
      // this.cityData.forEach((element) => {
      //   if (element.Title === args.rowData.city) {
      //     this.cityObj.value = element.Identity;
      //     this.getCitySubdivision(this.cityObj.value);

      //     setTimeout(() => {
      //       this.citySubdivisionData.forEach((element) => {
      //
      //         if (element.Title === args.rowData.citySubdivision) {
      //
      //           this.citySubdivisonObj.value = element.Identity;
      //         }
      //       });
      //     }, 500);
      //   }
      // });

      this.serviceListData.forEach((element) => {
        if (element.Title === args.rowData.serviceId) {
          this.serviceObj.value = element.Identity as any;
        }
      });
      this.agreementCodeData.forEach((element) => {
        if (element.Title === args.rowData.agreementCode) {
          this.agreementObj.value = element.Identity;
        }
      });

      this.dateMask.value = args.rowData.contactTelephone;
    }
  }

  commandClick(args: CommandClickEventArgs): void {
    // this.cityObj = null;
    // this.citySubdivisonObj = null;
  }

  keyPressed(args) {
    this.isKeyPressed = args.key == 'Enter';
  }

  cityAndCitySubdivisonAndService() {
    // this.cityParams = {
    //   create: () => {
    //
    //     this.cityElem = document.createElement('input');
    //     (this.cityElem as any).name = 'city';
    //     return this.cityElem;
    //   },
    //   read: () => {
    //     return this.cityObj.text;
    //   },
    //   destroy: () => {
    //     this.cityObj.destroy();
    //   },
    //   write: () => {
    //     this.cityObj = new DropDownList({
    //       dataSource: this.cityData,
    //       fields: { value: 'Identity', text: 'Title' },
    //       value: this.cityObj != null ? this.cityObj.value : 0,
    //       showClearButton: true,
    //       allowFiltering: true,
    //       popupWidth: '200px',
    //       change: () => {
    //         // this.citySubdivisonObj.enabled = true;
    //         let tempQuery: Query = new Query().where(
    //           'Title',
    //           'equal',
    //           this.cityObj.value
    //         );
    //         this.cityName = this.cityObj.value.toString();
    //         this.getCitySubdivision(this.cityObj.value);
    //         // this.citySubdivisonObj.query = tempQuery;
    //         // this.citySubdivisonObj.text = null;
    //         // this.citySubdivisonObj.dataBind();
    //       },
    //       placeholder: 'İl Seçiniz',
    //       // floatLabelType: 'Never',
    //     });
    //     this.cityObj.appendTo(this.cityElem);
    //   },
    // };

    // this.citySubdivisionPArams = {
    //   create: () => {
    //
    //     this.citySubdivisonElem = document.createElement('input');
    //     (this.citySubdivisonElem as any).name = 'citySubdivision';
    //     return this.citySubdivisonElem;
    //   },
    //   read: () => {
    //     return this.citySubdivisonObj.text;
    //   },
    //   destroy: () => {
    //     this.citySubdivisonObj.destroy();
    //   },
    //   write: () => {
    //     this.citySubdivisonObj = new DropDownList({
    //       dataSource: this.citySubdivisionData,
    //       fields: { value: 'Identity', text: 'Title' },
    //       value:
    //         this.citySubdivisonObj != null ? this.citySubdivisonObj.value : 0,
    //       enabled: true,
    //       showClearButton: true,
    //       allowFiltering: true,
    //       placeholder: 'İlçe Seçiniz',
    //       // floatLabelType: 'Never',
    //       change: () => {
    //         // this.citySubdivisonObj.enabled = true;
    //         this.citySubdivisonObj.value;
    //         this.citySubdivisionName = this.citySubdivisonObj.value.toString();
    //       },
    //     });
    //     this.citySubdivisonObj.appendTo(this.citySubdivisonElem);
    //   },
    // };

    this.serviceParams = {
      create: () => {
        this.serviceElem = document.createElement('input');
        (this.serviceElem as any).name = 'serviceId';
        if (this.serviceObj == null) {
          this.gridPkRequired = { required: false };
          this.gridGbRequired = { required: false };
        }
        return this.serviceElem;
      },
      read: () => {
        return this.serviceObj.text;
      },
      destroy: () => {
        this.serviceObj.destroy();
      },
      write: () => {
        this.serviceObj = new MultiSelect({
          dataSource: this.serviceListData,
          fields: { value: 'Identity', text: 'Title' },
          value: (this.serviceObj != null ? this.serviceObj.value : 0) as any,
          enabled: true,
          showClearButton: true,
          allowFiltering: true,
          placeholder: 'Hizmet Seçiniz',
          // floatLabelType: 'Never',
          change: (args) => {
            // burası e fatura eklendiğinde earşiv de eklenmesi için yapıldı ama eksik var
            // if (
            //   args.value.length > 0 &&
            //   args.value[args.value.length - 1] === 2 &&
            //   !(args.value as number[]).includes(22)
            // ) {
            //   (args.value as number[]).push(22);
            // }

            if (
              args.value.length > 0 &&
              ((args.value as any).indexOf(2) >= 0 ||
                (args.value as any).indexOf(52) >= 0)
            ) {
              this.gridPkRequired = { required: [true, 'Pk zorunludur'] };
              this.gridGbRequired = { required: [true, 'Gb zorunludur'] };
              this.textBoxPkObj.element.value = 'urn:mail:defaultpk@';
              this.textBoxGbObj.element.value = 'urn:mail:defaultgb@';
              this.textBoxGbObj.enabled = true;
              this.textBoxPkObj.enabled = true;
            } else {
              this.gridPkRequired = { required: false };
              this.gridGbRequired = { required: false };
              this.textBoxPkObj.element.value = '';
              this.textBoxGbObj.element.value = '';
              this.textBoxGbObj.enabled = false;
              this.textBoxPkObj.enabled = false;
            }
            if (
              args.value.length > 0 &&
              (args.value as any)?.indexOf(5010) >= 0
            ) {
              this.agreementDateShow = true;
              this.gridAgreementStartTimeRequired = {
                required: [true, 'Başlangıç tarihi zorunludur'],
              };
              this.gridAgreementEndTimeRequired = {
                required: [true, 'Bitiş tarihi zorunludur'],
              };
              this.startDateObject.enabled = true;
              this.endDateObject.enabled = true;
            } else {
              this.agreementDateShow = false;
              this.startDateObject.value = null;
              this.endDateObject.value = null;

              this.gridAgreementStartTimeRequired = {
                required: [false],
              };
              this.gridAgreementEndTimeRequired = {
                required: [false],
              };
              this.startDateObject.enabled = false;
              this.endDateObject.enabled = false;
            }
          },
        });
        this.serviceObj.appendTo(this.serviceElem);
      },
    };

    this.agreementParams = {
      create: () => {
        this.agreementElem = document.createElement('input');
        return this.agreementElem;
      },
      read: () => {
        return this.agreementObj.text;
      },
      destroy: () => {
        this.agreementObj.destroy();
      },
      write: () => {
        this.agreementObj = new DropDownList({
          dataSource: this.agreementCodeData,
          fields: { value: 'Identity', text: 'Title' },
          value: this.agreementObj != null ? this.agreementObj.value : 0,
          enabled: true,
          showClearButton: true,
          allowFiltering: true,
          placeholder: 'Sözleşme Seçiniz',
          // floatLabelType: 'Never',
          change: (args) => {},
        });
        this.agreementObj.appendTo(this.agreementElem);
      },
    };

    this.textBoxPkParams = {
      create: () => {
        this.textBoxPkElem = document.createElement('input');
        return this.textBoxPkElem;
      },
      read: () => {
        return this.textBoxPkObj.element.value;
      },
      destroy: () => {
        this.textBoxPkObj.destroy();
      },
      write: (args: { rowData: object; column: Column }) => {
        this.textBoxPkObj = new TextBox({
          value: args.rowData[args.column.field],
          showClearButton: true,
          placeholder: 'Posta Kodu Etiket(urn:mail:defaultpk@örnek.com.tr)',
          floatLabelType: 'Always',
        });
        this.textBoxPkObj.appendTo(this.textBoxPkElem);
      },
    };

    this.startDateEditOptions = {
      create: () => {
        this.elemStartDate = document.createElement('input');
        return this.elemStartDate;
      },
      read: () => {
        return (this.startDateObject as DatePicker).value;
      },
      destroy: () => {
        (this.startDateObject as DatePicker).destroy();
      },
      write: (args: { rowData: Object; column: Column } | any) => {
        this.startDateObject = new DatePicker({
          value: args.rowData[args.column.field],
          placeholder: 'Sözleşme Başlangıç Tarihi',
        });
        this.startDateObject.appendTo(this.elemStartDate);
      },
    };

    this.endDateEditOptions = {
      create: () => {
        this.elemEndDate = document.createElement('input');
        return this.elemEndDate;
      },
      read: () => {
        return (this.endDateObject as DatePicker).value;
      },
      destroy: () => {
        (this.endDateObject as DatePicker).destroy();
      },
      write: (args: { rowData: Object; column: Column } | any) => {
        this.endDateObject = new DatePicker({
          value: args.rowData[args.column.field],
          placeholder: 'Sözleşme Bitiş Tarihi',
        });
        this.endDateObject.appendTo(this.elemEndDate);
      },
    };

    this.dateTimePickerAgreementParams = {
      create: () => {
        this.dateTimePickerAgreementElem =
          document.createElement('datetimepicker');
        return this.dateTimePickerAgreementElem;
      },
      read: () => {
        return this.dateTimePickerAgreementObj.value;
      },
      destroy: () => {
        this.dateTimePickerAgreementObj.destroy();
      },
      write: (args: { rowData: object; column: any }) => {
        args.column.editTemplate = args.column.edit;
        // const dates: string = args.rowData[args.column.field]?.split('/');
        this.dateTimePickerAgreementObj = new DatePicker({
          value: args.rowData[args.column.field],

          floatLabelType: 'Never',
        });
        this.dateTimePickerAgreementObj.appendTo(
          this.dateTimePickerAgreementElem,
        );
      },
    };

    this.textBoxGbParams = {
      create: () => {
        this.textBoxGbElem = document.createElement('input');
        return this.textBoxGbElem;
      },
      read: () => {
        return this.textBoxGbObj.element.value;
      },
      destroy: () => {
        this.textBoxGbObj.destroy();
      },
      write: (args: { rowData: object; column: Column }) => {
        this.textBoxGbObj = new TextBox({
          value: args.rowData[args.column.field],
          showClearButton: true,
          placeholder:
            'Gönderici Birim Etiket(urn:mail:defaulgbk@örnek.com.tr)',
          floatLabelType: 'Always',
        });
        this.textBoxGbObj.appendTo(this.textBoxGbElem);
      },
    };

    this.maskedTextBoxTelephone = {
      create: () => {
        this.elem = document.createElement('input');
        (this.elem as any).name = 'contactTelephone';
        return this.elem;
      },
      read: () => {
        return this.dateMask.value;
      },
      destroy: () => {
        this.dateMask.destroy();
      },
      write: (args: { rowData: object; column: Column }) => {
        this.dateMask = new MaskedTextBox({
          value: this.dateMask != null ? this.dateMask.value : null,
          width: 200,
          cssClass: 'e-maskalign',
          mask: '000-000-00-00',
          floatLabelType: 'Always',
        });
        this.dateMask.appendTo(this.elem);
      },
    };
  }

  private fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target?.result as string;
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  private injectFileInputsToDialog(
    dialogElement: HTMLElement,
    rowData?: any,
  ): void {
    const form = dialogElement.querySelector('.e-gridform');
    if (!form) return;

    if (dialogElement.querySelector('#file-upload-section')) return;

    const MAX_SIZE_KB = 30;
    const MAX_SIZE_BYTES = MAX_SIZE_KB * 1024;

    const section = document.createElement('div');
    section.id = 'file-upload-section';
    section.style.cssText =
      'display:flex; gap:12px; align-items:center; padding:12px 0 4px 0;';

    section.innerHTML = `
    <div style="display:flex; gap:6px;">
      <div style="display:flex; align-items:center; gap:8px;">
        <button type="button" id="btn-logo-pick"
          style="padding:5px 14px; background:#2563eb; color:#fff; border:none;
                 border-radius:5px; cursor:pointer; font-size:13px;">
          Logo Görseli Seçiniz
        </button>
        <span id="logo-file-name" style="font-size:12px; color:#6b7280;">
          ${rowData?.logoImageBase64Data ? '✔ Mevcut logo var' : 'Seçilmedi'}
        </span>
      </div>
      <div style="display:flex; align-items:center; gap:8px;">
        <button type="button" id="btn-signature-pick"
          style="padding:5px 14px; background:#0e7490; color:#fff; border:none;
                 border-radius:5px; cursor:pointer; font-size:13px;">
          İmza Görseli Seçiniz
        </button>
        <span id="signature-file-name" style="font-size:12px; color:#6b7280;">
          ${rowData?.signatureImageBase64Data ? '✔ Mevcut imza var' : 'Seçilmedi'}
        </span>
      </div>
    </div>
    <input type="file" id="logo-file-input" accept="image/*" style="display:none" />
    <input type="file" id="signature-file-input" accept="image/*" style="display:none" />
  `;

    form.appendChild(section);

    // Logo
    const logoInput = section.querySelector(
      '#logo-file-input',
    ) as HTMLInputElement;
    const logoLabel = section.querySelector('#logo-file-name') as HTMLElement;

    section
      .querySelector('#btn-logo-pick')!
      .addEventListener('click', () => logoInput.click());

    logoInput.addEventListener('change', () => {
      if (!logoInput.files?.length) return;
      const file = logoInput.files[0];

      if (file.size > MAX_SIZE_BYTES) {
        logoLabel.textContent = `⚠ Dosya ${MAX_SIZE_KB}KB'dan büyük olamaz!`;
        logoLabel.style.color = '#ef4444';
        logoInput.value = '';
        if (rowData) rowData.logoImageBase64Data = undefined;
        return;
      }

      this.fileToBase64(file).then((base64) => {
        if (rowData) rowData.logoImageBase64Data = base64;
        logoLabel.textContent = `✔ ${file.name}`;
        logoLabel.style.color = '#16a34a';
      });
      logoInput.value = '';
    });

    // İmza
    const signatureInput = section.querySelector(
      '#signature-file-input',
    ) as HTMLInputElement;
    const signatureLabel = section.querySelector(
      '#signature-file-name',
    ) as HTMLElement;

    section
      .querySelector('#btn-signature-pick')!
      .addEventListener('click', () => signatureInput.click());

    signatureInput.addEventListener('change', () => {
      if (!signatureInput.files?.length) return;
      const file = signatureInput.files[0];

      if (file.size > MAX_SIZE_BYTES) {
        signatureLabel.textContent = `⚠ Dosya ${MAX_SIZE_KB}KB'dan büyük olamaz!`;
        signatureLabel.style.color = '#ef4444';
        signatureInput.value = '';
        if (rowData) rowData.signatureImageBase64Data = undefined;
        return;
      }

      this.fileToBase64(file).then((base64) => {
        if (rowData) rowData.signatureImageBase64Data = base64;
        signatureLabel.textContent = `✔ ${file.name}`;
        signatureLabel.style.color = '#16a34a';
      });
      signatureInput.value = '';
    });
  }
}
